import { api } from './api.js';

/**
 * Même adresse que côté serveur, en dur là aussi : ce n'est qu'un confort
 * d'affichage (afficher ou non le lien) — le contrôle qui compte est refait
 * par le serveur à chaque appel.
 */
export const ADMIN_EMAIL = 'pierre.noilhan@gmail.com';

export const listerUtilisateurs = () => api.get('/admin/users');
export const listerVoyagesUtilisateur = (userId) =>
  api.get(`/admin/users/${userId}/trips`).then((d) => d.trips);
export const desactiverCompte = (userId) =>
  api.patch(`/admin/users/${userId}/disable`).then((d) => d.user);
export const reactiverCompte = (userId) =>
  api.patch(`/admin/users/${userId}/enable`).then((d) => d.user);
